import styled from 'styled-components';
import color from '../../configs/color';
// import breakpoints from '../../configs/breakpoints'

const Wrapper = styled.div`
  padding: 4px 16px;
  border-radius: 8px;
  background-color: ${(props) => {
    if (props.purple) {
      return color.purple6;
    }

    if (props.orange) {
      return color.orange6;
    }

    return color.green6;
  }};
  color: ${(props) => {
    if (props.purple) {
      return color.purple1;
    }

    if (props.orange) {
      return color.orange1;
    }

    return color.green1;
  }};
  border-radius: 100px;
  display: inline-block;

  &.inactive {
    background-color: ${color.black5};
    color: ${color.black3};
  }
`;

export default Wrapper;
